module.exports = __webpack_public_path__ + "static/media/sufit2.265325a2.jpg";